const iconWithText = document.querySelector("[js-hb-icon-with-text");
if (iconWithText) {
  const tabTitle = iconWithText.querySelectorAll("[js-hb-tabs]");
  const tabHbContent = iconWithText.querySelectorAll("[js-hb-tab-content]");
  tabTitle[0]?.classList.add("active");
  tabHbContent[0]?.classList.add("active");
}
document.querySelectorAll(".hb-grid").forEach(function (gridItem) {
  gridItem.addEventListener("click", function () {
    const blockId = this.getAttribute("data-block-id");
    document
      .querySelectorAll(".hb_tab-content.mobile")
      .forEach(function (tabContent) {
        tabContent.classList.remove("active");
      });

    document.querySelectorAll(".hb-grid").forEach(function (grid) {
      grid.classList.remove("active");
    });
    this.classList.add("active");
    const targetTabContent = document.querySelector(`#${blockId}`);
    if (targetTabContent) {
      targetTabContent.classList.add("active");
    }
  });
});

document.querySelectorAll("[js-accordion-main]").forEach((accordionMain) => {
  accordionMain.addEventListener("click", function () {
    const parentAccordion = this;
    const content = parentAccordion.querySelector("[js-accordion-content]");
    const isOpen = parentAccordion.classList.contains("is-open");
    document
      .querySelectorAll("[js-accordion-main].is-open")
      .forEach((openAccordion) => {
        if (openAccordion !== parentAccordion) {
          openAccordion.classList.remove("is-open");
          openAccordion.querySelector(
            "[js-accordion-content]"
          ).style.maxHeight = null;
        }
      });
    if (isOpen) {
      parentAccordion.classList.remove("is-open");
      content.style.maxHeight = null;
    } else {
      parentAccordion.classList.add("is-open");
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  function togglePurchaseOptionBlocks() {
    const selectedOption = document.querySelector(
      'input[name="purchase_option"]:checked'
    );
    const isSubscription =
      selectedOption && selectedOption.value === "subscription";

    // Toggle display
    document
      .querySelectorAll(".variant_top-text.with_subscription")
      .forEach((el) => {
        el.style.display = isSubscription ? "block" : "none";
      });

    document
      .querySelectorAll(".variant_top-text.without_subscription")
      .forEach((el) => {
        el.style.display = isSubscription ? "none" : "block";
      });
  }

  // Initial run
  togglePurchaseOptionBlocks();

  // Listen for change on all purchase_option radios
  const purchaseOptions = document.querySelectorAll(
    'input[name="purchase_option"]'
  );
  purchaseOptions.forEach((radio) => {
    radio.addEventListener("change", togglePurchaseOptionBlocks);
  });
});

const mainProductContainer = document.querySelector("[js-main-product]");
if (mainProductContainer) {
  const subscriptionOption = mainProductContainer.querySelector("[js-subscription-option]");

  if (subscriptionOption) {
    const subscriptionInfo = mainProductContainer.querySelector("[js-subscription-info]");
    const menge1Option = mainProductContainer.querySelector("input[value='1 X 500g']");
    const menge2Option = mainProductContainer.querySelector("input[value='2 X 500g']");
    const oneTimePurchaseLabel = mainProductContainer.querySelector("[js-one-time-purchase-label]");
    const quantityField = mainProductContainer.querySelector("[js-quantity-field]");
    const tipVariantField = mainProductContainer.querySelector("[js-tip-variant-field]");
    const tipVariantMasterIdField = mainProductContainer.querySelector("[js-tip-variant-master-id-field]");

    if (menge1Option) {
      if (menge1Option.checked) {
        subscriptionInfo.classList.remove("hidden");
        subscriptionOption.classList.add("is-disabled");
      }

      document.addEventListener("change", function ({ target }) {
        const value = target.value;
        if (target.closest("[js-menge-option]")) {
          if (value === "1 X 500g") {
            subscriptionOption.classList.add("is-disabled");
            subscriptionInfo.classList.remove("hidden");
            oneTimePurchaseLabel.click();
          } else {
            subscriptionOption.classList.remove("is-disabled");
            subscriptionInfo.classList.add("hidden");

            if (quantityField) {
              quantityField.value = 1;
              tipVariantMasterIdField.setAttribute("disabled", "disabled");
            }
            if (tipVariantField) {
              tipVariantField.checked = false;
            }
          }
        };

        if (target.closest("[js-recharge-widget]") && value === "subscription" && menge1Option.checked) {
          subscriptionOption.classList.remove("is-disabled");
          subscriptionInfo.classList.add("hidden");
          menge2Option?.labels[0].click();
        }

        if (target.hasAttribute("js-tip-variant-field")) {
          const mengeFieldLabel = mainProductContainer.querySelector(`label[for='${menge1Option?.getAttribute("id")}'`);

          if (mengeFieldLabel && quantityField) {
            if (target.checked) {
              mengeFieldLabel.click();
              quantityField.value = 5;
              tipVariantMasterIdField.removeAttribute("disabled");
            } else {
              quantityField.value = 1;
              tipVariantMasterIdField.setAttribute("disabled", "disabled");
            }
          }
        }
      })
    }
  }
}